module.exports = __webpack_public_path__ + "assets/img/9a9a949d9353163aa495eb9d2db3fd5b.svg";